"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isKeyFactory = isKeyFactory;
exports.useKey = useKey;
exports.useButtonKeys = useButtonKeys;
exports.isHome = exports.isEnd = exports.isUp = exports.isDown = exports.isRight = exports.isLeft = exports.isEscape = exports.isSpace = exports.isEnter = void 0;
var _react = require("react");
var Keys = {
  Enter: {
    key: 'Enter',
    keyCode: 13
  },
  Space: {
    key: 'Space',
    keyCode: 32
  },
  Escape: {
    key: 'Escape',
    keyCode: 27
  },
  ArrowLeft: {
    key: 'ArrowLeft',
    keyCode: 37
  },
  ArrowRight: {
    key: 'ArrowRight',
    keyCode: 39
  },
  ArrowDown: {
    key: 'ArrowDown',
    keyCode: 40
  },
  ArrowUp: {
    key: 'ArrowUp',
    keyCode: 38
  },
  End: {
    key: 'End',
    keyCode: 35
  },
  Home: {
    key: 'Home',
    keyCode: 36
  }
};
function checkKey(e, keyName) {
  var keyValues = Keys[keyName];
  return e.key === keyValues.key || e.keyCode === keyValues.keyCode;
}
function isKeyFactory(keyName) {
  return function checkSpecificKey(e) {
    return checkKey(e, keyName);
  };
}
var isEnter = isKeyFactory('Enter');
exports.isEnter = isEnter;
var isSpace = isKeyFactory('Space');
exports.isSpace = isSpace;
var isEscape = isKeyFactory('Escape');
exports.isEscape = isEscape;
var isLeft = isKeyFactory('ArrowLeft');
exports.isLeft = isLeft;
var isRight = isKeyFactory('ArrowRight');
exports.isRight = isRight;
var isDown = isKeyFactory('ArrowDown');
exports.isDown = isDown;
var isUp = isKeyFactory('ArrowUp');
exports.isUp = isUp;
var isEnd = isKeyFactory('End');
exports.isEnd = isEnd;
var isHome = isKeyFactory('Home');
exports.isHome = isHome;
function useKey(keyName, isKey) {
  if (isKey === void 0) {
    isKey = isKeyFactory(keyName);
  }
  var _a = (0, _react.useState)(false),
    keyPressed = _a[0],
    setKeyPressed = _a[1];
  var onKeyDown = function onKeyDown(e) {
    if (isKey(e)) {
      setKeyPressed(true);
    }
  };
  var onKeyUp = function onKeyUp(e) {
    if (isKey(e)) {
      setKeyPressed(false);
    }
  };
  (0, _react.useEffect)(function () {
    window.addEventListener('keydown', onKeyDown);
    window.addEventListener('keyup', onKeyUp);
    return function () {
      window.removeEventListener('keydown', onKeyDown);
      window.removeEventListener('keyup', onKeyUp);
    };
  }, []);
  return keyPressed;
}
function useButtonKeys() {
  return {
    isEnterPressed: useKey('Enter'),
    isSpacePressed: useKey('Space'),
    isEscapePressed: useKey('Escape'),
    isLeftPressed: useKey('ArrowLeft'),
    isRightPressed: useKey('ArrowRight'),
    isDownPressed: useKey('ArrowDown'),
    isUpPressed: useKey('ArrowUp'),
    isHomePressed: useKey('Home'),
    isEndPressed: useKey('End')
  };
}